import { Badge } from '../ui/badge';
import { USER_STATUS_META, type UserStatus } from '../../lib/userStatus';

interface Props {
    /** Estado del usuario. Puede venir undefined en filas incompletas → muestra "—". */
    status?: UserStatus;
}

// Badge de estado de usuario. Reúne el mapeo status → { label, variant } compartido para que todas
// las tablas/menús pinten el mismo badge sin duplicar el criterio.
export function StatusBadge({ status }: Props) {
    const meta = status ? USER_STATUS_META[status] : undefined;
    return <Badge variant={meta?.variant ?? 'secondary'}>{meta?.label ?? '—'}</Badge>;
}
